/****************************************************
 * Module Name:  holdProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class HoldProxy {


    static GetCustomersCreatedHold = (userid, usertype, stonetype, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stone/hold/customers/${userid}/${usertype}`,
            "post",
            Constants.userToken,
            undefined,
            stonetype,
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}